export default [
    {
        name: 'H1N1_6WCR_Model',
        type: 'dracoModel',
        path: '/my-threejs-project/models/H1N1_6WCR.glb'
    }
]